import React from "react";
const SmallTitle = ({ title }) => {
  return <h3 className=" text-base font-bold mb-6 text-[#010202]">{title}</h3>;
};

export default SmallTitle;
